module.exports = __webpack_public_path__ + "img/Utilities_Recall_3_Set.e271fc47.png";